import { FC, useState } from "react";

import { TimeListItemDisplay } from "./time-list-item.display";
import { TimeListItemEdit } from "./time-list-item.edit";
import { ITimeListItemForm } from "./time-list-item.models";

export const TimeListItem: FC<ITimeListItemForm> = ({
  fieldName,
  index,
  value,
  setValueOuter,
  removeHandler,
  disabledEdit,
  disabledRemove,
}) => {
  const [inEdit, setInEdit] = useState(false);
  return (
    <>
      {!inEdit && (
        <TimeListItemDisplay
          fieldName={fieldName}
          index={index}
          value={value}
          removeHandler={removeHandler}
          onEdit={() => {
            setInEdit(true);
          }}
          disabledEdit={disabledEdit}
          disabledRemove={disabledRemove}
        />
      )}

      {inEdit && (
        <TimeListItemEdit
          fieldName={fieldName}
          setValueOuter={setValueOuter}
          index={index}
          value={value}
          onCancelOuter={() => {
            setInEdit(false);
          }}
        />
      )}
    </>
  );
};
